import React, { useEffect, useLayoutEffect, useState } from 'react';
import FactorKolUp from './FactorKolUp';
import FactorKolDown from './FactorKolDown';

const FactorKol = (props) => {

  // useEffect(()=>{
  //   console.log(props.options)
  //   console.log(props.factorOptions)
  // },[])
  
  return (
    <>
      <FactorKolUp options={props.options} />
      <FactorKolDown options={props.factorOptions}/>
    </>
  );
};

export default FactorKol;
